/**
 * Форматирование float значений с backend
 * @param value
 */
export const formatFloat = (value: string | number | null) => {
  if (typeof value === 'string') return parseFloat(value).toString()

  if (typeof value === 'number') return parseFloat(String(value)).toString()

  return ''
}
